// Sidebar.jsx
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  FiHome,
  FiUsers,
  FiFolder,
  FiCalendar,
  FiBarChart2,
  FiFileText,
  FiMapPin,
  FiDollarSign,
  FiUpload,
  FiCreditCard,
  FiUser,
  FiRepeat,
  FiPlus,
  FiChevronDown,
  FiLogOut,
  FiSettings,
  FiShield,
} from "react-icons/fi";
import { RiFileList3Line, RiBuilding2Line } from "react-icons/ri";
import { LuFileSpreadsheet } from "react-icons/lu";
import { localStorageKey, screenPath } from "../constant/strings";
import logo from "../assets/images/logo.png";
import "./styles/Sidebar.css";
import CommonModal from "./CommonModal";
import CompanySwitcher from "./CompanySwitcher";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const loginType =
    localStorage.getItem(localStorageKey.userType) || "accountant";
  const selectedCompany = useSelector(
    (state) => state?.company?.selectedCompany,
  );
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [showSignOutModal, setShowSignOutModal] = useState(false);

  const accountantMenu = [
    { Icon: FiHome, label: "Dashboard", path: screenPath.dashboardPage },
    { Icon: FiUsers, label: "Clients", path: screenPath.clientPage },
    { Icon: FiCalendar, label: "Users", path: screenPath.usersPage },
    {
      Icon: LuFileSpreadsheet,
      label: "Invoices",
      path: screenPath.accountantInvoices,
    },
    {
      Icon: RiFileList3Line,
      label: "Entries",
      path: screenPath.accountantEntries,
    },
    {
      Icon: FiFolder,
      label: "Documents",
      path: screenPath.accountantDocuments,
    },
    { Icon: FiCalendar, label: "Events", path: screenPath.accountantEvents },
    {
      Icon: FiDollarSign,
      label: "Personal Tax",
      path: screenPath.personalTaxPage,
    },
    { Icon: FiCalendar, label: "Exports", path: screenPath.accountantExports },
    { Icon: FiUser, label: "Profile", path: screenPath.profileCompanyPage },
  ];

  const companyMenu = [
    { Icon: FiHome, label: "Dashboard", path: screenPath.dashboardCompanyPage },
    { Icon: FiUsers, label: "Clients", path: screenPath.clientPage },
    { Icon: FiCalendar, label: "Users", path: screenPath.usersPage },
    {
      Icon: FiRepeat,
      label: "Transaction",
      path: screenPath.transactionCompanyPage,
    },
    {
      Icon: FiBarChart2,
      label: "Reports",
      path: screenPath.accountantReports,
    },
    {
      Icon: FiDollarSign,
      label: "Personal Tax",
      path: screenPath.personalTaxPage,
    },
    {
      Icon: FiFileText,
      label: "New Invoice",
      path: screenPath.newInvoiceCompanyPage,
    },
    {
      Icon: FiDollarSign,
      label: "Log Expenses",
      path: screenPath.logExpensesCompanyPage,
    },
    {
      Icon: FiMapPin,
      label: "Record Mileage",
      path: screenPath.recordMileageCompanyPage,
    },
    {
      Icon: FiCreditCard,
      label: "Bank Statement",
      path: screenPath.bankStatementCompanyPage,
    },
    {
      Icon: FiUpload,
      label: "Upload Data",
      path: screenPath.uploadDataCompanyPage,
    },
    { Icon: FiCalendar, label: "Events", path: screenPath.accountantEvents },
    { Icon: FiUser, label: "Profile", path: screenPath.profileCompanyPage },
  ];

  const adminMenu = [
    { Icon: FiHome, label: "Dashboard", path: screenPath.adminDashboard },
    { Icon: FiUsers, label: "Accountants", path: screenPath.adminDashboard }, // Same path for now or different if created
    { Icon: FiSettings, label: "Settings", path: "#" },
  ];

  const menuItems =
    loginType === "admin"
      ? adminMenu
      : loginType === "company"
        ? companyMenu
        : accountantMenu;

  const handleNavigate = (path) => {
    navigate(path);
  };

  const handleSignOut = () => {
    localStorage.clear();
    navigate(screenPath.chooseUser);
  };

  return (
    <>
      <aside className="modern-sidebar">
        {/* Header */}
        <div className="sidebar-header">
          <div className="logo-section">
            <img src={logo} alt="Logo" className="logo-img" />
            <div>
              <h3>
                {loginType === "admin"
                  ? "Admin"
                  : loginType === "accountant"
                    ? "Accountant"
                    : "Company"}
              </h3>
              <p className="username">
                {loginType === "admin"
                  ? "Administrator"
                  : loginType === "accountant"
                    ? "Kowsalya Acc"
                    : "Srijith"}
              </p>
            </div>
          </div>

          {loginType === ("accountant" || "company") && (
            <div
              className="company-chip"
              // onClick={() => setIsCompanyModalOpen(true)}
              onClick={() => navigate(screenPath.accountantSelectCompany)}
            >
              <RiBuilding2Line className="chip-icon" />
              <div>
                <span className="change-texttop">Selected Company</span>
                <div className="company-name">
                  {selectedCompany?.name || selectedCompany?.business_name}
                </div>
                <span className="change-text">Change</span>
              </div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <button
                key={item.label}
                onClick={() => handleNavigate(item.path)}
                className={`nav-btn ${isActive ? "active" : ""}`}
              >
                <item.Icon className="nav-icon" />
                <span>{item.label}</span>
                {isActive && <div className="active-indicator" />}
              </button>
            );
          })}
        </nav>

        {/* Sign Out */}
        <div className="sidebar-footer">
          <button
            className="signout-btn"
            onClick={() => setShowSignOutModal(true)}
          >
            <FiLogOut className="signout-icon" />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>

      {/* Sign Out Confirmation Modal */}
      {showSignOutModal && (
        <div
          className="modal-backdrops"
          onClick={() => setShowSignOutModal(false)}
        >
          <div className="modal-contents" onClick={(e) => e.stopPropagation()}>
            <h3>Sign Out</h3>
            <p>Are you sure you want to sign out?</p>
            <div className="modal-actionss">
              <button
                className="btn-cancel"
                onClick={() => setShowSignOutModal(false)}
              >
                Cancel
              </button>
              <button className="btn-signout" onClick={handleSignOut}>
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
      {/* {isCompanyModalOpen && (
        <CommonModal
          isOpen={isCompanyModalOpen}
          onClose={() => setIsCompanyModalOpen(false)}
          title="Switch Company"
        >
          <CompanySwitcher onClose={() => setIsCompanyModalOpen(false)} />
        </CommonModal>
      )} */}
    </>
  );
}
